export const micrositeConfigFolder = "config";
